import axios from "axios";
import { API_BASE_URL, API_BASE_URL1 } from "../Services/baseApiUrl";
import axiosInstance from "../../Hooks/axoisInstance";
//const countryId =localStorage.getItem("country_Id");

const getToken = () => {
    return localStorage.getItem("token");
  };



export const AllOwnerTypeDetails = async () => {
    try {
      const response = await axios.get( API_BASE_URL1 +`MasterDetails/GetAllOwnerTypes`,
      {
        headers: {
          Authorization: `Bearer ${getToken()}`
        }
      }
      );
      return response.data;
    } catch (error) {
      throw error;
      
    }
  };


  export const CreateOwnerTypeDetails = async (ownerTypeData) => {
    try {
      const response = await axiosInstance.post( API_BASE_URL1 +`MasterCreate/AddNewOwnerType`,ownerTypeData,
      {
        headers: {
          Authorization: `Bearer ${getToken()}`
        }
      }
      );
      return response.data;
    } catch (error) {
      throw error;
     
    }
  };

  export const UpdateOwnerTypeDetails = async (ownerTypeData) => {
    try {
      const response = await axiosInstance.put( API_BASE_URL1 +`MasterCreate/UpdateOwnerTypeDetails`,ownerTypeData,
      {
        headers: {
          Authorization: `Bearer ${getToken()}`
        }
      }
      );
      return response.data;
    } catch (error) {
      throw error;
      // console.log(error)
    }
  };

  export const getOwnerTypeById = async (id) => {
    try {
        const response = await axiosInstance.get(API_BASE_URL1 + `owner_type/getById/${id}`,
            {
                headers: {
                    Authorization: `Bearer ${getToken()}`
                },

            });
        // console.log(response, 'response')
        return response;
    } catch (error) {
        throw error
    }
};